export const getNewsLink = (companyId: string, prId: string) => {
    return `/companies/${companyId}/press-releases/${prId}`
}
